import { MdOutlineHighlightOff } from 'react-icons/md';
import { Button } from '@ds';
import { CaseStatus } from '@/api/apis/case';
import { caseStatusNames } from '@/constants/case/case.constants';

type SelectedStatusProps = {
  status: CaseStatus;
  onClick: () => void;
};

export const SelectedStatus = ({ status, onClick }: SelectedStatusProps) => {
  return (
    <Button
      variant="light"
      className="flex w-full bg-transparent rounded-lg justify-between items-center py-2 px-3 text-m-m!"
      endContent={<MdOutlineHighlightOff size={16} color="#F05252" />}
      onClick={onClick}
    >
      {caseStatusNames[status]}
    </Button>
  );
};
